(function () {
  function initRoot(root) {
    if (!root || root.dataset.newMegaInit === '1') return;
    root.dataset.newMegaInit = '1';

    var tabs = root.querySelectorAll('[data-new-mega-tab]');
    var panels = root.querySelectorAll('[data-new-mega-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      var i = String(index);
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-new-mega-tab') === i);
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-new-mega-panel') === i);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        activate(tab.getAttribute('data-new-mega-tab'));
      });
      tab.addEventListener('focusin', function () {
        activate(tab.getAttribute('data-new-mega-tab'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-new-mega-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
